import {RouterData} from 'contexts/RouterContext';
import {NavigationItemExtended, ServiceData} from 'models/app';
import {MARKETPLACE_PREFIX, SOLUTIONS_PREFIX, SERVICES_PREFIX} from './config/constants';
import {NavigationSectionType} from './models';

export function isSearchPage(router: RouterData) {
    return router.pathname === '/search';
}

export function applySearch(
    searchRaw: string,
    navigationItems: NavigationItemExtended[],
): NavigationItemExtended[] {
    const search = searchRaw.toLowerCase();

    return navigationItems.filter(
        ({name, slug, description}) =>
            (name && name.toLowerCase().includes(search)) ||
            slug.includes(search) ||
            (description && description.toLowerCase().includes(search)),
    );
}

export const getNavigationTitleLink = (
    slug: string,
    type: NavigationSectionType,
    queryName: string,
): string => {
    return type === NavigationSectionType.Services
        ? `/${getNavigationTypePrefix(type)}#${slug}`
        : `/${getNavigationTypePrefix(type)}?${queryName}=${slug}`;
};

export const getNavigationItemLink = (slug: string, type: NavigationSectionType): string =>
    `/${getNavigationTypePrefix(type)}/${slug}`;

export const getNavigationItemUrl = (
    navigationItem: NavigationItemExtended,
    type: NavigationSectionType,
    path: string,
    isNavigation?: boolean,
) => {
    let url = getNavigationItemLink(navigationItem.slug, type);

    if (!isNavigation) {
        if (type === NavigationSectionType.Services) {
            url = getServiceUrl(navigationItem as ServiceData, path);
        }
    }

    return url;
};

function getServiceUrl(serviceItem: ServiceData, path: string): string {
    let url = '';
    const {docUrl, pricesUrl} = serviceItem;

    if (docUrl && path.endsWith('docs')) {
        url = docUrl;
    }

    if (pricesUrl && path.endsWith('prices')) {
        url = pricesUrl;
    }

    return url;
}

export function getNavigationTypePrefix(type: NavigationSectionType): string {
    switch (type) {
        case NavigationSectionType.Solutions:
            return SOLUTIONS_PREFIX;
        case NavigationSectionType.Services:
        default:
            return SERVICES_PREFIX;
    }
}

export const getMarketplaceLink = () => {
    return `/${MARKETPLACE_PREFIX}`;
};

export function getLinks(item: ServiceData) {
    const links = [];

    if (item?.docUrl) {
        links.push({
            url: item.docUrl,
            text: 'doc-link',
        });
    }
    if (item?.pricesUrl) {
        links.push({
            url: item.pricesUrl,
            text: 'prices-link',
        });
    }

    return links;
}
